import React, { FC } from 'react';

import { Paragraph } from '~/components/Paragraph';
import { Heading } from '~/components/Heading';

import { ModalStatus } from '../types';

export interface HeaderProps {
  label?: string;
  status: ModalStatus;
  children: React.ReactNode;
}

const color = {
  [ModalStatus.Loading]: 'idle',
  [ModalStatus.Idle]: 'idle',
  [ModalStatus.Warning]: 'warning',
  [ModalStatus.Alert]: 'alert',
  [ModalStatus.Success]: 'success',
};

const HeaderBase: FC<HeaderProps> = ({ status, children, label }) => {
  return (
    <React.Fragment>
      {label && (
        <Paragraph color={color[status]} fontSize={1} bold mb={0}>
          {label}
        </Paragraph>
      )}
      <Heading as="h1" variant="h2" mb="m">
        {children}
      </Heading>
    </React.Fragment>
  );
};

HeaderBase.defaultProps = {
  status: ModalStatus.Idle,
};

export const Header = Object.assign(HeaderBase, {
  defaultProps: HeaderBase.defaultProps,
});
try {
    // @ts-ignore
    Header.displayName = "Header";
    // @ts-ignore
    Header.__docgenInfo = { "description": "", "displayName": "Header", "props": { "label": { "defaultValue": null, "description": "", "name": "label", "required": false, "type": { "name": "string" } }, "status": { "defaultValue": { value: "ModalStatus.Idle" }, "description": "", "name": "status", "required": true, "type": { "name": "ModalStatus" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Modal/Header/index.tsx#Header"] = { docgenInfo: Header.__docgenInfo, name: "Header", path: "src/components/Modal/Header/index.tsx#Header" };
}
catch (__react_docgen_typescript_loader_error) { }